import React, { useState } from "react";
import { connect } from "react-redux";
import { arrayOf, bool, func, object, shape, string } from "prop-types";
import { Link } from "react-router-dom";
import history from "../../history";
import ReadingStatus from "../ReadingListDownload/reading_status";
import { markDocumentReadGrowUpFarms } from "../../redux/actions";
import { filenameFromUrl } from "../../common/OnboardingSectionCreator/helpers";
import ReadingListDownload from "../ReadingListDownload/index";
import OnboardingListItem from "../OnboardingListItem/OnboardingListItem";

const GrowUpFarmsOnboarding = ({
  markDocumentRead,
  readingLoading,
  readingList,
  onboarding,
  foodSafetyLoading,
}) => {
  const [currentlyReading, setCurrentlyReading] = useState(null);
  const readDocuments = (onboarding && onboarding.readDocuments) || [];

  const readingListWithStatus = readingList
    .map((download) => ({
      ...download,
      status: readDocuments.includes(filenameFromUrl(download.link))
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));

  const isFormCompleted = (typeCode) => !!(onboarding && onboarding[typeCode]);
  const healthAndSafety = {
    status: isFormCompleted("YGU2") ? 3 : 1,
    title: "Health & Safety Induction Questionnaire",
    text: "Complete",
    url: "grow-up-farms-onboarding/health-and-safety-questionnaire",
  };

  const foodSafetyResults =
    onboarding && onboarding.foodSafetyQuestionnaireResults;
  const foodSafetySubmitted = foodSafetyResults && onboarding.YGUF;
  const foodSafety = {
    status: isFormCompleted("YGUF") ? 3 : 1,
    title: "Food Safety Questionnaire",
    text: "Complete",
    url: "/profile/edit/grow-up-farms-onboarding/food-and-safety-questionnaire",
    loading: foodSafetyLoading,
    downloadingDisabled: true,
  };

  return (
    <div className="container text-bluishGray pb-2">
      <header className="row">
        <div className="col-12">
          <h2 className="section-header pt-2">GrowUp Farms Induction Pack</h2>
        </div>
      </header>
      <div className="row">
        <div className="col-lg-6">
          <div className="section-body pt-1 mb-2 bg-white">
            <h5 className="px-1">Reading List</h5>
            <p className="p-1" style={{ width: "90%" }}>
              You are required to download and read each document below before
              you start work. You will then be asked to tick the box to confirm
              you have read and understood and agree to each document. If you
              have any queries, please speak to your HRGO Consultant.
            </p>
            {readingListWithStatus &&
              readingListWithStatus.map((elem, i) => (
                <ReadingListDownload
                  key={i}
                  title={elem.title}
                  link={elem.link}
                  status={elem.status}
                  agreementText={`I have read and understood the ${elem.title}.`}
                  currentlyReading={currentlyReading}
                  setCurrentlyReading={setCurrentlyReading}
                  markDocumentRead={markDocumentRead}
                  isLoading={readingLoading}
                />
              ))}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="section-body pt-1 mb-2 bg-white">
            <h5 className="px-1">Questionnaire</h5>
            <p className="p-1">
              Please complete the questionnaires below. If you have any queries,
              please speak to your HRGO Consultant.
            </p>
            <OnboardingListItem
              title={healthAndSafety.title}
              status={healthAndSafety.status}
              btnText={healthAndSafety.text}
              key={healthAndSafety.title}
              url={healthAndSafety.url}
            />
            <OnboardingListItem
              title={foodSafety.title}
              status={foodSafety.status}
              btnText={foodSafety.text}
              key={foodSafety.title}
              loading={foodSafety.loading}
              downloadingDisabled={foodSafety.downloadingDisabled}
              handleClick={() => history.push(foodSafety.url)}
            />
          </div>
          {foodSafetySubmitted && (
            <div className="section-body bg-white py-2 my-1 mt-lg-0">
              <h5 className="px-1">Food Safety Questionnaire</h5>
              <h5 className="px-1">Results</h5>
              {Object.entries(foodSafetyResults.results).map(([key, value]) => (
                <div
                  key={key}
                  style={{
                    display: "flex",
                    padding: "0 1rem",
                    justifyContent: "space-between",
                  }}
                >
                  <p>{key}</p>
                  <p>{value} / 1</p>
                </div>
              ))}
              <div
                style={{
                  display: "flex",
                  padding: "0 1rem",
                  justifyContent: "space-between",
                }}
              >
                <p>
                  <b>SCORE</b>
                </p>
                <p>
                  <b>
                    {foodSafetyResults.sum}/
                    {Object.keys(foodSafetyResults.results).length} ={" "}
                    {foodSafetyResults.score}%
                  </b>
                </p>
              </div>
              <p
                style={{
                  padding: "0 1rem",
                }}
              >
                The pass rate for this questionnaire is 95%
              </p>
            </div>
          )}
        </div>
        <div className="w-100 d-flex justify-content-end mt-2 mr-2">
          <Link to="/profile" className="btn btn-primary px-3">
            Back to My Account
          </Link>
        </div>
      </div>
    </div>
  );
};

GrowUpFarmsOnboarding.propTypes = {
  markDocumentRead: func.isRequired,
  onboarding: object,
  readingLoading: bool,
  foodAndSafetyLoading: bool,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
};
const mapStateToProps = (state) => ({
  onboarding: state.core.app.growUpFarmsOnboarding,
  readingLoading: state.core.growUpFarmsReading.isLoading,
  readingList: state.core.umbracoContent.growUpFarmsReadingList,
  foodSafetyLoading: state.core.growUpFarmsFoodQuestionnaire.isLoading,
});
const mapDispatchToProps = {
  markDocumentRead: markDocumentReadGrowUpFarms,
};
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(GrowUpFarmsOnboarding);
